<template>
  <div class="content">
    <!-- 筛选查询框 -->
    <el-form :inline="true" class="demo-form-inline" size="small">
      <el-form-item label="分类: " style="margin:0 30PX">
        <el-select
          style="width:260px"
          v-model="select_one_id"
          placeholder="请选择"
          @change="selecCategoryBtn"
          clearable
        >
          <div v-for="item in categoryArr" :key="item.id">
            <el-option :label="item.categoryName" :value="item.id"></el-option>
          </div>
        </el-select>
      </el-form-item>
      <el-form-item label="商品名称: " style="margin-left:20px">
        <el-input v-model="productName" placeholder="请输入商品名称" style="width:250px" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="selectAll">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="ejectaddGoods">新增商品</el-button>
      </el-form-item>
    </el-form>
    <!-- 商品表格 -->
    <el-table
      border
      :data="goodsArr"
      style="width: 100%;overflow-y: scroll;"
      height="calc(100vh - 220px)"
      v-loading="loading"
      element-loading-spinner="el-icon-loading"
      element-loading-text="正在加载中"
    >
      <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
      <el-table-column label="商品id" width="180" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.id ? scope.row.id : "暂无id" }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="商品编码" width="180" align="center">
          <template slot-scope="scope">
            <span>{{
              scope.row.productCode ? scope.row.productCode : "暂无编码"
            }}</span>
          </template>
      </el-table-column>-->
      <el-table-column label="产品名" width="200" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.productName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="商品库存" width="200" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.stockNum }}</span>
        </template>
      </el-table-column>
      <el-table-column label="划去的价格(不设置小程序不显示)" width="150" align="center">
        <template slot-scope="scope">
          <span>
            {{
            scope.row.discountPrice ? scope.row.discountPrice + "元" : "未设置"
            }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="售价" width="150" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.price }}元</span>
        </template>
      </el-table-column>
      <el-table-column label="运费" width="150" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.freight?scope.row.freight:0 }}元</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="产品类型" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.productType }}</span>
          </template>
      </el-table-column>-->
      <!-- <el-table-column label="产品描述" align="center">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <p>{{ scope.row.introduce }}</p>
              <div slot="reference" class="name-wrapper">
                <el-tag size="medium">{{
                  scope.row.introduce ? scope.row.introduce : "暂无"
                }}</el-tag>
              </div>
            </el-popover>
          </template>
      </el-table-column>-->
      <!-- <el-table-column
          label="商品封面图"
          :label-width="formLabelWidth"
          width="100"
        >
          <template slot-scope="scope">
            <img :src="scope.row.coverImg" alt style="width:100%" />
          </template>
      </el-table-column>-->
      <el-table-column label="状态" min-width="100" align="center">
        <template slot-scope="scope">
          <span>
            {{
            scope.row.status === 0
            ? "上架"
            : scope.row.status === 1
            ? "预售"
            : scope.row.status === 2
            ? "补货"
            : scope.row.status === 3
            ? "下架"
            : "-"
            }}
          </span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="视频链接" align="center" width="250">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <p>
                {{ scope.row.videoLink }}
              </p>
              <div slot="reference" class="name-wrapper">
                <el-tag size="medium" class="text-hide">{{
                  scope.row.videoLink ? scope.row.videoLink : "暂无"
                }}</el-tag>
              </div>
            </el-popover>
          </template>
      </el-table-column>-->
      <el-table-column label="上架时间" min-width="200" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="140" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="text" @click="ejectupdataGoods(scope.row)">信息修改</el-button>
          <el-button size="mini" type="text" @click="ejectupdataImgs(scope.row)">图片维护</el-button>
          <el-button size="mini" type="text" @click="showCreateCode(scope.row)">二维码生成</el-button>
          <el-button
            size="mini"
            type="text"
            style="color: rgb(255, 0, 0);"
            @click="deleteGoods(scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 产品提交表单 -->
    <el-dialog
      :title="inpitTypeName"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="form">
        <el-form-item label="商品分类: " :label-width="formLabelWidth" required>
          <el-select v-model="form.productCategory" placeholder="请选择商品分类">
            <div v-for="item in categoryArr" :key="item.id">
              <el-option :label="item.categoryName" :value="item.id"></el-option>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="商品状态:" :label-width="formLabelWidth" required>
          <el-select v-model="form.status" placeholder="不填写默认为上架">
            <div v-for="item in statusArr" :key="item.id">
              <el-option :label="item.status" :value="item.id"></el-option>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="是否取样:" :label-width="formLabelWidth">
          <el-select v-model="form.is_write" placeholder="不填写默认为不需要取样">
            <div v-for="item in writeArr" :key="item.id">
              <el-option :label="item.name" :value="item.id"></el-option>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="商品封面图" :label-width="formLabelWidth" width="100" required>
          <img :src="form.coverImg" alt style="width:100px;margin-bottom:5px" />
          <el-input v-model="form.coverImg" placeholder="上传后自动获取地址" clearable></el-input>
        </el-form-item>
        <el-upload
          class="upload-demo"
          :action="action"
          :multiple="true"
          :on-remove="handleRemove"
          :on-success="coverImgBtn"
          :file-list="fileList"
          list-type="picture"
          name="formData"
        >
          <el-button size="small" type="primary">点击上传商品封面图(1张)</el-button>
          <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，500px X 500px</div>
        </el-upload>
        <!-- <el-form-item label="商品编码" :label-width="formLabelWidth">
          <el-input v-model="form.productCode" auto-complete="off"></el-input>
        </el-form-item>-->
        <el-form-item label="商品名称" :label-width="formLabelWidth" required>
          <el-input v-model="form.productName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="商品库存" :label-width="formLabelWidth">
          <el-input v-model="form.stockNum" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="一盒数量或包装" :label-width="formLabelWidth">
          <el-input v-model="form.package" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="商品描述(请勿输入&特殊字符)" :label-width="formLabelWidth">
          <el-input v-model="form.introduce" auto-complete="off" type="textarea"></el-input>
        </el-form-item>
        <!-- <el-form-item
          label="使用方法说明(请勿输入&特殊字符)"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="form.wayMessage"
            auto-complete="off"
            type="textarea"
          ></el-input>
        </el-form-item>-->
        <el-form-item label="划去的价格(不设置小程序不显示)" :label-width="formLabelWidth">
          <el-input v-model="form.discountPrice" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="售价" :label-width="formLabelWidth" required>
          <el-input v-model="form.price" auto-complete="off" type="number"></el-input>
        </el-form-item>
        <el-form-item label="运费" :label-width="formLabelWidth">
          <el-input v-model="form.freight" auto-complete="off" type="number" placeholder="不填写默认为0"></el-input>
        </el-form-item>
        <!-- <el-form-item label="商品视频链接" :label-width="formLabelWidth">
          <el-input v-model="form.videoLink" auto-complete="off"></el-input>
        </el-form-item>-->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updataBtn">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 图片提交表单 -->
    <el-dialog
      :title="inpitTypeName"
      :visible.sync="dialogImgVisible"
      :close-on-click-modal="false"
    >
      <div class="imgUrlBox">
        <h2>商品主图</h2>
        <div class="imgUrlBoxShow">
          <div v-for="(item, index) in headerImg" :key="index" @click="handleEditImg(item)">
            <img :src="item.imgUrl" alt style="width:100%" />
          </div>
        </div>
        <el-upload
          class="upload-demo"
          :action="action"
          :multiple="false"
          :on-remove="handleRemove"
          :on-success="headerImgBtn"
          :file-list="fileList"
          list-type="picture"
          name="formData"
        >
          <el-button size="small" type="primary">点击新增商品主图(最多5张)</el-button>
          <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，500px X 500px, 上传后在尾部新增一条</div>
        </el-upload>
      </div>

      <div class="detailsImgBox">
        <h2>商品详情图</h2>
        <div class="detailsImgBoxShow">
          <div v-for="(item, index) in detailsImg" :key="index" @click="handleEditImg(item)">
            <img :src="item.imgUrl" alt style="width:100%" />
          </div>
        </div>
        <el-upload
          class="upload-demo"
          :action="action"
          :multiple="false"
          :on-remove="handleRemove"
          :on-success="detailsImgBtn"
          :file-list="fileList"
          list-type="picture"
          name="formData"
        >
          <el-button size="small" type="primary">点击新增商品详情图（10张内）</el-button>
          <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，500px X 500px,上传后在尾部新增一条</div>
        </el-upload>

        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogImgVisible = false" type="primary">返 回</el-button>
          <!-- <el-button type="primary" @click="updataImgBtn">确 定</el-button> -->
        </div>
      </div>
    </el-dialog>

    <!-- 图片操作弹窗 -->
    <el-dialog title="操作选中的图片" :visible.sync="imgEditVisible" :close-on-click-modal="false">
      <el-form :model="imgObj">
        <el-form-item label :label-width="formLabelWidth" width="100">
          <img :src="imgObj.imgUrl" alt style="width:100px" />
        </el-form-item>
        <el-form-item label :label-width="formLabelWidth" width="100">
          <el-upload
            class="upload-demo"
            :action="action"
            :multiple="false"
            :on-remove="handleRemove"
            :on-success="updateImgBtn"
            :file-list="fileList"
            list-type="picture"
            name="formData"
          >
            <el-button size="small" type="primary">修改替换图片</el-button>
            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，500px X 500px</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="排序大小" :label-width="formLabelWidth">
          <el-input v-model="imgObj.sort" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="imgEditVisible = false">取 消</el-button>
        <el-button @click="handleDeleteImgItem">删 除</el-button>
        <el-button type="primary" @click="handleSaveImgItem">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 生成二维码弹窗 -->
    <el-dialog title="生成商品二维码" :visible.sync="codeDialogVisible" :close-on-click-modal="false">
      <el-form :model="codeForm">
        <!-- <el-form-item label="write_id(非必填)" :label-width="formLabelWidth">
          <el-input v-model="codeForm.write_id" placeholder="填写后关联取样商品订单"></el-input>
        </el-form-item>-->

        <el-form-item label="是否需要取样:" :label-width="formLabelWidth">
          <div>{{form.is_write == 1?'需要':'不需要'}}</div>
        </el-form-item>

        <el-form-item>
          <span
            style="color:#999;font-size:12px;"
          >不需要取样的商品生成通用二维码;需要取样的商品生成唯一的二维码，患者扫码填报寄回样品后，管理员扫码可以直接打开此订单</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="codeDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleCreateCode">生 成</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  selectGoods,
  addGoods,
  updateGoods,
  deleteGoodbyid,
  selectCategory,
  deleteGoodsbygoodsId,
  //新增图片相关接口
  selectImg,
  addImg,
  updateImg,
  deleteImg
} from "@/services/mall/goods";
import { IP } from "@/services/index.js";
import { createCode } from "@/services/system/getCode.js";

// import { addSku, selectSku, deleteSku } from "@/services/sku";
export default {
  created() {
    this.selectAll();
    // 查询一级分类
    selectCategory("0").then(res => {
      console.log(res);
      this.categoryArr = res.data;
    });
  },

  data() {
    return {
      status: 0,
      statusArr: [
        { id: 0, status: "上架" },
        { id: 1, status: "预售" },
        { id: 2, status: "补货" },
        { id: 3, status: "下架" }
      ],
      writeArr: [
        { id: 0, name: "不取样" },
        { id: 1, name: "需要取样" }
      ],
      goodsTitle: "",
      tableData: [],
      categoryId: "",
      productName: "",
      // 一级分类 二级分类 商品
      select_one_id: "",
      categoryArr: [],
      nextCategoryArr: [],
      goodsArr: [],
      dialogFormVisible: false, //产品信息维护
      dialogImgVisible: false, //产品图维护
      imgEditVisible: false,
      imgObj: {},
      formLabelWidth: "120px",
      action: IP + "/uploadFile/add",
      fileList: [],
      loading: true,
      form: {},
      inpitTypeName: "",
      headerImg: [],
      detailsImg: [],
      sku: [], //sku数组
      skuActive: "",
      skuForm: {
        //新增sku
        productId: "",
        price: "",
        sku: ""
      },
      skuVisible: false,
      codeDialogVisible: false,
      codeForm: {
        write_id: "",
        goodsId: ""
      }
    };
  },
  methods: {
    selectAll() {
      selectGoods({
        id: this.select_one_id,
        productName: this.productName
      }).then(resp => {
        this.loading = false;
        this.goodsArr = resp.data;
      });
    },
    // 根据分类id查二级分类
    selecCategoryBtn(e) {
      this.selectAll();
    },

    coverImgBtn(e) {
      this.form.coverImg = e.data;
    },

    /* 新增商品主图 */
    headerImgBtn(e) {
      addImg({
        productId: this.form.id,
        imgUrl: e.data,
        imgType: 1
      }).then(res => {
        this.fileList = [];
        this.handleSeletImg();
      });
    },

    /* 新增详情图 */
    detailsImgBtn(e) {
      addImg({
        productId: this.form.id,
        imgUrl: e.data,
        imgType: 2
      }).then(res => {
        this.fileList = [];
        this.handleSeletDeatilImg();
      });
    },

    /* 编辑图片 */
    updateImgBtn(e) {
      this.fileList = [];
      this.imgObj.imgUrl = e.data;
    },

    /*  移除上传的内容 */
    handleRemove(e, fileList) {
      console.log("移除---------------", e, fileList);
    },

    ejectupdataGoods(row) {
      this.dialogFormVisible = true;
      this.inpitTypeName = "修改商品详情";
      this.form = JSON.parse(JSON.stringify(row));
      this.fileList = [];
    },

    ejectaddGoods() {
      this.dialogFormVisible = true;
      this.inpitTypeName = "新增商品";
      this.form = {};
      this.select_one_id = "";
      this.fileList = [];
    },

    ejectupdataImgs(row) {
      this.dialogImgVisible = true;
      this.inpitTypeName = "商品图片维护";
      this.form = JSON.parse(JSON.stringify(row));
      this.fileList = [];
      //查询
      this.handleSeletImg();
      this.handleSeletDeatilImg();
    },

    /* 根据商品id查询主图 */
    handleSeletImg() {
      selectImg({ productId: this.form.id, imgType: 1 }).then(res => {
        console.log("主图", res);
        this.headerImg = res.data;
      });
    },

    /* 根据商品id查询详情图 */
    handleSeletDeatilImg() {
      selectImg({ productId: this.form.id, imgType: 2 }).then(res => {
        console.log("详情图", res);
        this.detailsImg = res.data;
      });
    },

    /* 编辑图片弹窗 */
    handleEditImg(row) {
      this.fileList = [];
      this.imgEditVisible = true;
      this.imgObj = JSON.parse(JSON.stringify(row));
    },

    /* 删除图片 */
    handleDeleteImgItem() {
      console.log(this.imgObj.id);
      this.$confirm("此操作将永久删除该图片吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deleteImg({ id: this.imgObj.id }).then(resp => {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.imgEditVisible = false;
            //查询
            this.handleSeletImg();
            this.handleSeletDeatilImg();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },

    /* 保存编辑的图片 */
    handleSaveImgItem() {
      console.log(this.imgObj);
      updateImg(this.imgObj).then(resp => {
        this.$message({
          type: "success",
          message: "修改成功!"
        });
        this.imgEditVisible = false;
        //查询
        this.handleSeletImg();
        this.handleSeletDeatilImg();
      });
    },

    /* 提交商品详情按钮 */
    updataBtn() {
      if (
        this.form.productCategory == "" ||
        this.form.productCategory == undefined
      ) {
        this.$message.error("商品分类不能为空");
        return;
      }
      if (this.form.coverImg == "" || this.form.coverImg == undefined) {
        this.$message.error("商品封面图不能为空");
        return;
      }
      if (this.form.price == "" || this.form.price == undefined) {
        this.$message.error("商品价钱不能为空");
        return;
      }
      if (!this.form.productName) {
        this.$message.error("请填写商品名称");
        return;
      }

      if (!this.form.freight) {
        this.form.freight = 0;
      }

      if (this.inpitTypeName == "修改商品详情") {
        updateGoods(this.form).then(resp => {
          if (resp.code == 200) {
            this.$message.success("修改成功");
            this.dialogFormVisible = false;
            this.selectAll();
          } else {
            this.$message.error("修改失败");
          }
        });
        return;
      }

      addGoods(this.form).then(resp => {
        if (resp.code == 200) {
          this.$message.success("上传成功");
          this.dialogFormVisible = false;
          this.selectAll();
        } else {
          this.$message.error("上传失败");
        }
      });
    },

    /* 删除商品 */
    deleteGoods(row) {
      console.log(row.id);
      this.$confirm("此操作将永久删除该商品, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          console.log(row.id);
          deleteGoodbyid(row.id).then(resp => {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            deleteGoodsbygoodsId(row.id).then(res => {});
            this.selectAll();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },

    /* 商品二维码二维码 */
    showCreateCode(row) {
      // 保持与表单一致，便于根据 form.is_write 判断
      this.form = JSON.parse(JSON.stringify(row));
      this.codeForm.goodsId = row.id;
      // 当需要取样时，自动生成10位秒级时间戳作为 write_id
      this.codeForm.write_id =
        this.form && this.form.is_write == 1
          ? String(Math.floor(Date.now() / 1000))
          : "";
      this.codeDialogVisible = true;
    },
    handleCreateCode() {
      createCode({
        pageUrl: "pages/details/details",
        goodsId: this.codeForm.goodsId,
        write_id: this.codeForm.write_id || ""
      }).then(res => {
        if (res.code === 200) {
          this.$message({
            type: "success",
            message: "创建成功,前往下载!"
          });
          this.codeDialogVisible = false;
          setTimeout(() => {
            window.open(res.data, "_blank");
          }, 1000);
        } else {
          this.$message({
            type: "error",
            message: res.data
          });
        }
      });
    }
  }
};
</script>

<style scoped>
.content {
  margin: 10px auto;
  width: 98%;
}
.el-pagination {
  text-align: center;
  margin: 20px;
}
.goodsTitle:hover {
  cursor: pointer;
}
.upload-demo {
  margin: 20px;
}

.imgUrlBox,
.detailsImgBox {
  width: 100%;
}

.imgUrlBox {
  margin-bottom: 80px;
}
.imgUrlBoxShow {
  display: flex;
}
.imgUrlBoxShow > div {
  margin: 10px;
  width: 100px;
  height: 100px;
  overflow: hidden;
  border: 1px dotted rgb(93, 93, 93);
}
.imgUrlBoxShow > div:hover {
  cursor: pointer;
}
.detailsImgBoxShow > div {
  border: 1px dotted rgb(93, 93, 93);
  margin: 0 auto;
}
.detailsImgBoxShow > div:hover {
  cursor: pointer;
}
.detailsImgBoxShow > div img {
  width: 100%;
}
.dialog-footer {
  display: flex;
  justify-content: center;
}
</style>
